/******************************
 * GENERATED FILE, DO NOT EDIT *
 *******************************/ import type {
  ReactNode,
  SVGProps,
} from "react";
export default function IconClock(props: SVGProps<SVGSVGElement>): ReactNode {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16px"
      height="16px"
      fill="none"
      viewBox="0 0 20 20"
      color="currentColor"
      {...props}
    >
      <path
        fill="currentColor"
        d="M9.236 3.897a.763.763 0 1 1 1.525 0 .763.763 0 0 1-1.525 0M9.236 16.1a.763.763 0 1 1 1.525 0 .763.763 0 0 1-1.525 0M4.05 10.762a.763.763 0 1 1 0-1.526.763.763 0 0 1 0 1.526M15.95 10.762a.763.763 0 1 1 0-1.526.763.763 0 0 1 0 1.526M6.224 14.853a.763.763 0 1 1-1.079-1.08.763.763 0 0 1 1.08 1.08M14.854 6.224a.763.763 0 1 1-1.079-1.08.763.763 0 0 1 1.08 1.08M13.775 14.853a.763.763 0 1 0 1.08-1.08.763.763 0 0 0-1.08 1.08M5.145 6.224a.763.763 0 1 0 1.079-1.079.763.763 0 0 0-1.079 1.079"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        strokeWidth={1.2}
        d="M19 9.999C19 15.054 15.054 19 9.999 19S.998 15.054.998 9.999 4.944.998 9.999.998 19 4.944 19 9.999"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        strokeWidth={1.2}
        d="M9.999 6.948v2.419c0 .404.16.792.447 1.079l1.841 1.841"
      />
    </svg>
  );
}
